import axios from 'axios'

axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

export default {
    get: (url) => {
        return axios.get('/api' + url);
    },
    getExternal: (url, headers) => {
        if (headers) {
            return axios.get(url, { headers: headers })
        }
        else {
            return axios.get(url);
        }
    },
    post: (url, data) => {
        return axios.post('/api' + url, data);
    }
}
